import "./styles/main.scss";
import {ThemeProvider} from '@mui/material/styles';
import {InLabB2BTheme} from "@/theme/Inlabb2b";
import {Provider} from 'react-redux';
import Store from "@/store/Store";
import CssBaseline from "@mui/material/CssBaseline";
import ErrorsCatcher from "./components/ErrorsCatcher/Tsx/ErrorsCatcher";
import ShowGlobalError from "./components/ShowGlobalError/Tsx/ShowGlobalError";
import TranslationProvider from "./common/Providers/TranslationProvider/TranslationProvider";
import RunRootServiceWorker from "./Other/RunRootServiceWorker/Tsx/RunRootServiceWorker";
import {AppRoutes} from "@/routes/AppRoutes";
import AppLocalizationProvider from "@/common/Providers/AppLocalizationProvider/AppLocalizationProvider";
import {
    LkNotificationPrefetcher
} from "@/features/InControlPanel/ReferenceBooks/Lists/LkNotification/LkNotificationPrefetcher";

function App() {
    return (
      <Provider store={Store}>
          <ThemeProvider theme={InLabB2BTheme}>
              <CssBaseline/>
              <ShowGlobalError/>

              <ErrorsCatcher errorId="8f6d6238-eed0-46f5-b191-e286b262d75c">
                  <TranslationProvider>
                      <LkNotificationPrefetcher/>
                      <AppLocalizationProvider>
                          <AppRoutes/>
                      </AppLocalizationProvider>
                  </TranslationProvider>
              </ErrorsCatcher>

              <ErrorsCatcher errorId="1ebca624-9c6f-4bb6-9962-6ddcd7f45576">
                  <RunRootServiceWorker/>
              </ErrorsCatcher>

          </ThemeProvider>
      </Provider>
    );
}

export default App;
